var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Novo plano")]),_c('b-card',{attrs:{"no-body":""}},[_c('Form',{on:{"saved":_vm.loadData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }